import styled from 'styled-components';
import { CANDY_APPLE, OZ } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcceptedStatusInfoContainer = styled.div.withConfig({
  displayName: "AcceptedStatusInfo__AcceptedStatusInfoContainer",
  componentId: "tmhot1-0"
})(["align-self:start;vertical-align:baseline;"]);
const AcceptedStatusInfo = ({
  acceptedStatus,
  displayMode
}) => {
  switch (acceptedStatus) {
    case 'ACCEPTED':
      return /*#__PURE__*/_jsxs(AcceptedStatusInfoContainer, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-2",
          color: OZ,
          name: "success"
        }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.metCriteria"
        })]
      });
    case 'REJECTED':
      {
        if (displayMode === 'OPTIMISTIC_ACCEPTED') {
          return /*#__PURE__*/_jsxs(AcceptedStatusInfoContainer, {
            children: [/*#__PURE__*/_jsx(UIHelpIcon, {
              className: "m-right-2",
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.noEvalData"
              }),
              tooltipPlacement: "left"
            }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.metCriteria"
            })]
          });
        }
        return /*#__PURE__*/_jsxs(AcceptedStatusInfoContainer, {
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-2",
            color: CANDY_APPLE,
            name: "remove"
          }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.didNotMeetCriteria"
          })]
        });
      }
    default:
      return null;
  }
};
export default AcceptedStatusInfo;